import { AssetClaimsModule } from '@folio/modules/AssetClaimsModule';
import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { PolicyClaimsModule } from '@korint/folio';
import { useTranslation } from 'react-i18next';
import { Stack } from '@folio/components/ui/flex';

export function PolicyClaims() {
  const { t } = useTranslation();
  const { policy } = usePolicyOnDashboard();

  if (policy.productId !== 'axeceVtc') {
    return <AssetClaimsModule />;
  }

  return (
    <Stack>
      <PolicyClaimsModule title={t('claims.driver1Title')} claimsMetadata={{ driver: '1' }} />
      {!!policy.customFields.secondDriverOption && (
        <PolicyClaimsModule title={t('claims.driver2Title')} claimsMetadata={{ driver: '2' }} />
      )}
    </Stack>
  );
}
